import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initWebVitals } from './utils/analytics/webVitals';
import ItemsProvider from './data/context';

const rootElement = document.getElementById('root') as HTMLElement;

// Check if we're hydrating (react-snap) or rendering fresh
if (rootElement.hasChildNodes()) {
  // Hydrate the pre-rendered content
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <ItemsProvider>
        <App />
      </ItemsProvider>
    </React.StrictMode>
  );
} else {
  // Fresh render
  const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ItemsProvider>
      <App />
    </ItemsProvider>
  </React.StrictMode>
);
}

// Initialize enhanced Web Vitals monitoring
initWebVitals();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
